import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";
import { Textarea } from "@/components/ui/textarea";
import { api, fmtDate, formatErr } from "@/lib/api";
import { ADDON_LABELS } from "@/data/options";

export const AddonForm = () => {
  const [services, setServices] = useState([]);
  const [details, setDetails] = useState("");
  const [history, setHistory] = useState([]);
  const load = () => api.get("/member/addon-requests").then((r) => setHistory(r.data)).catch(() => {});
  useEffect(() => {
    load();
  }, []);
  const toggle = (k) => setServices((s) => (s.includes(k) ? s.filter((x) => x !== k) : [...s, k]));
  const submit = async () => {
    if (!services.length) return toast.error("Choose at least one service.");
    try {
      await api.post("/member/addon-requests", { services, details });
      toast.success("Request sent. We'll get back to you with a quote.");
      setServices([]);
      setDetails("");
      load();
    } catch (e) {
      toast.error(formatErr(e));
    }
  };
  return (
    <div className="grid gap-6 lg:grid-cols-2">
      <div className="rounded-2xl border border-border bg-card p-6 space-y-4" data-testid="member-addon-form">
        <p className="text-sm text-muted-foreground">Add-on services are quoted separately and not included in your membership.</p>
        {Object.entries(ADDON_LABELS).map(([k, l]) => (
          <label key={k} className="flex items-center gap-3 rounded-xl border border-border p-3 cursor-pointer hover:border-primary transition-colors">
            <Checkbox checked={services.includes(k)} onCheckedChange={() => toggle(k)} data-testid={`member-addon-${k}`} />
            <span className="font-semibold">{l}</span>
          </label>
        ))}
        <Textarea rows={4} placeholder="Tell us what you need (volume, destination, timing...)" value={details} onChange={(e) => setDetails(e.target.value)} className="rounded-xl" data-testid="member-addon-details" />
        <button onClick={submit} className="h-11 px-6 rounded-full bg-primary text-primary-foreground font-bold inline-flex items-center gap-2 btn-glow" data-testid="member-addon-submit"><Send className="h-4 w-4" />Request a quote</button>
      </div>
      <div className="space-y-3">
        <p className="font-bold">Your requests</p>
        {history.length === 0 && <p className="text-sm text-muted-foreground">No requests yet.</p>}
        {history.map((h) => (
          <div key={h.id} className="rounded-xl border border-border bg-card p-4 text-sm" data-testid={`member-addon-history-${h.id}`}>
            <p className="font-bold">{h.services.map((s) => ADDON_LABELS[s]).join(", ")}</p>
            <p className="text-muted-foreground">{h.status} · {fmtDate(h.created_at)}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
